export default __webpack_public_path__ + "static/media/main-logo.33fff79f.png";